module.exports = __webpack_public_path__ + "static/media/12.b19c35a7.wav";